import * as React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { ICalendarAppState } from '../redux-state';
import { IStartupState } from '../redux-state/interfaces/startup.state';

import { activeFilterOptions } from '../helpers/active-filter-options';

interface StateToProps {
    localStorageState: IStartupState;
}

/**
 * Utility class to save filter / date-range state to `localStorage` when a promo-code is applied or removed.
 */
class PromoCodeHelper extends React.Component<StateToProps> {
    componentDidMount() {
        const promoFormContainer = document.getElementById('promoCodeBlock');
        const promoForm = promoFormContainer.querySelector('form') as HTMLFormElement;
        promoForm.addEventListener('submit', () => {
            localStorage.setItem('calendarState', JSON.stringify(this.props.localStorageState));
        });
    }
    render() {
        return null;
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {

    const startDate = state.calendar.dateRangeFromQueryString ?
        state.calendar.startupState.startDate :
        moment().format('YYYY-MM-DD');

    const endDate = state.calendar.dateRangeFromQueryString ?
        state.calendar.startupState.endDate :
        moment(state.calendar.loadedMonths[state.calendar.loadedMonths.length - 1]).endOf('month').format('YYYY-MM-DD');

    const currentDate = state.calendar.currentDate.format('YYYY-MM-DD');
    const dateRangeFromQueryString = state.calendar.dateRangeFromQueryString;
    const typeFilter = activeFilterOptions(state.calendar.typeFilter);
    const genreFilter = activeFilterOptions(state.calendar.genreFilter);
    const venueFilter = activeFilterOptions(state.calendar.venueFilter);
    const availabilityFilter = activeFilterOptions(state.calendar.availabilityFilter);

    return {
        localStorageState: {
            currentDate,
            startDate,
            endDate,
            dateRangeFromQueryString,
            typeFilter,
            genreFilter,
            venueFilter,
            availabilityFilter
        }
    };
}

export default connect(mapStateToProps)(PromoCodeHelper);